<script setup lang="ts">
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';
import { storeToRefs } from 'pinia';
import MobileFilters from '@pages/search/components/filters/MobileFilters.vue';
import DesktopFilters from '@pages/search/components/filters/DesktopFilters.vue';
import { computed } from 'vue';
import { useAuthStore } from '@stores/useAuthStore.ts';

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());

const { isImpersonated } = storeToRefs(useAuthStore());

const topPosition = computed<string>(() => {
  if (isMobileOrTablet.value) {
    return isImpersonated.value ? 'top-12' : 'top-0';
  }

  // Desktop : header (64px) + banner (48px)
  return isImpersonated.value ? 'top-28' : 'top-16';
});
</script>

<template>
  <div
    :class="[
      `sticky z-10 ${topPosition}`,
      'border-b bg-white',
      'flex',
      isMobileOrTablet ? 'gap-2 p-2' : 'gap-4 p-4'
    ]"
  >
    <MobileFilters v-if="isMobileOrTablet" />

    <DesktopFilters v-else />
  </div>
</template>
